import { createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";

// API End Points
import { API_END_POINTS } from "../../Middleware/apiEndpoints";

//utils
import { notifyError } from "Services/Utils/toastNotification";


// API calls

export const fetchMiningNewsletterList = createAsyncThunk("fetchMiningNewsletterList", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.miningNewsletter}?page=${data.page}&limit=${data.limit}${data.sort_by ? `&sort_by=${data.sort_by}` : ""}${data.order_by ? `&order_by=${data.order_by}` : ""}${data.fromDate ? `&from_date=${data.fromDate}` : ""}${data.toDate ? `&to_date=${data.toDate}` : ""}${data.search ? `&search=${data.search}` : ""}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.miningNewsletter} ====> ${JSON.stringify(
        response?.data?.message
      )}`
    );
  }
  return response?.data;
});

export const fetchMiningContactList = createAsyncThunk("fetchMiningContactList", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.miningContactList}?page=${data.page}&limit=${data.limit}${data.sort_by ? `&sort_by=${data.sort_by}` : ""}${data.order_by ? `&order_by=${data.order_by}` : ""}${data.fromDate ? `&from_date=${data.fromDate}` : ""}${data.toDate ? `&to_date=${data.toDate}` : ""}${data.search ? `&search=${data.search}` : ""}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.miningContactList} ====> ${JSON.stringify(
        response?.data?.message
      )}`
    );
  }
  return response?.data;
});

export const fetchMiningSpeakBearingList = createAsyncThunk("fetchMiningSpeakBearingList", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.miningSpeakBearingList}?page=${data.page}&limit=${data.limit}${data.sort_by ? `&sort_by=${data.sort_by}` : ""}${data.order_by ? `&order_by=${data.order_by}` : ""}${data.fromDate ? `&from_date=${data.fromDate}` : ""}${data.toDate ? `&to_date=${data.toDate}` : ""}${data.search ? `&search=${data.search}` : ""}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.miningSpeakBearingList} ====> ${JSON.stringify(
        response?.data?.message
      )}`
    );
  }
  return response?.data;
});
